<div class="content-block">
  <article class="article " style="margin-top:1rem">

    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2 *ngIf="company != null">{{company.name}} Equipment Management</h2>
      </div>
      <div style="flex:1;justify-content: flex-end;display: flex;">
        <div class="add" (click)="add()" *ngIf="!readOnly">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <form style="width: 100%;" (submit)="rebind()">
      <div class="form-row borderless">
        <div class="form-row borderless " style="padding:0px;margin:0px;">
          <div class="col-md-3" *ngIf="showLocations">
            <div class="form-group">
              <label>Locations</label>
              <app-location-picker [locationId]="filter.locationId" [companyId]="filter.company_Id" [_placeholder]="'All'"
                (onLocationSet)="onLocationChange($event)"></app-location-picker>
            </div>
          </div>
    
          <div class="col-md-3">
            <div class="form-group">
              <label>Category</label>
              <app-category-picker [categoryId]="filter.category_Id" [_placeholder]="'All'"
                (onCategorySet)="onCategoryChange($event)"></app-category-picker>
    
            </div>
          </div>
    
          <div class="col-md-3 col-sm-6">
            <label>Serial #</label>
            <input type="text" name="serial_Num" [(ngModel)]="filter.serial_Num" />
          </div>
    
          <div class="col-md-3 col-sm-6">
            <label>Description</label>
            <input type="text" name="description" [(ngModel)]="filter.description" />
            </div>
            
            <div class="col-md-3 col-sm-6">
              <label>Enable Date Filter</label>
               <br />
              <input type="checkbox" id="switch-1" name="switch-1" role="switch" [(ngModel)]="filter.date_Enabled" />
            </div>

            <div class="col-md-3 col-sm-6">
              <label>Date Range</label>
              <select class="form-control" name="daterange" [(ngModel)]="filter.date_Range"
                (change)="dateChange($event.target.value)">
                <option value="-1">Predefined Date Range</option>  
                <option value="-2">Day</option>

                <option value="0">1 week</option>
                <option value="1">1 month</option>
                <option value="2">2 months</option>
                <option value="3">3 months</option>
                <option value="6">6 months</option>
                <option value="12">12 months</option>
              </select>
              </div>
            <div class="col-md-3 col-sm-6">
              <label>Start Date</label>
              <br />
              <p-calendar name="startdate" [(ngModel)]="filter.start_Date" dateFormat="dd/mm/yy"  (onSelect)="dateChanged()"  class="input"></p-calendar>
            </div>
            
            <div class="col-md-3 col-sm-6">
              <div *ngIf="filter.date_Range > -2">
                <label>End Date</label>
                <br />
                <p-calendar name="enddate" [(ngModel)]="filter.end_Date" dateFormat="dd/mm/yy"
                  (change)="dateChanged()"></p-calendar>
              </div>
            </div>
            
            
            </div>
      </div>
      <div class="form-row borderless " style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;">
         <div class="col-md-3 col-sm-6">
              <label>Job Number</label>
              <input type="text" name="doc" [(ngModel)]="filter.doc" />
            </div>
            <div class="col-md-3">
          <div class="form-group">
            <label>Inspection Status</label>
            <search-dropdown [ngModelOptions]="{standalone: true}" [items]="inspection_Statuss" [label]="'text'" [uid]="'value'" [placeholder]="'All'" (afterChange)="onStatusChanged($event)" [(ngModel)]="filter.inspection_Status"></search-dropdown>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group" *ngIf="!readOnly">
            <label>Archived Status</label>
            <search-dropdown [ngModelOptions]="{standalone: true}" [items]="archive_Items" [label]="'text'" [uid]="'value'" [placeholder]="'All'" (afterChange)="onArchiveChanged($event)" [(ngModel)]="filter.showArchived"> </search-dropdown>
          </div>
        </div>
        <div class="col-md-3 col-sm-6"></div>

        <div class="col-md-3 col-sm-6">
          <div class="btn-container" style="justify-content: flex-end;">

            <button class="btn btn-secondary"  (click)="resetFilters()">Reset</button>
            <button class="btn btn-primary"    value="Refresh">Refresh</button>
          </div>
        </div>


      </div>



    </form>
  </article>

  <div class="btn-container"
    style="padding-left: 0px;padding-right: 0px;min-height: 100px;width: 75vw;min-width: 300px;">


    <div class="btn-export-container shadow" style="margin-left: 0px;margin-right: 0px;min-height: 100px;">
      <label>Last Results</label>
      <div class="btn-container" style="justify-content: space-around;">

        <button class="btn btn-primary" (click)="exportResults(0)">Export
          Excel</button>
        <button class="btn btn-primary" (click)="exportResults(1)">Export
          PDF</button>
        <!-- <button class="btn btn-primary" *ngIf="selectedRows.length > 0" (click)="exportResults(0)">Export
          {{selectedRows.length}} items in Excel</button>
        <button class="btn btn-primary" *ngIf="selectedRows.length > 0" (click)="exportResults(1)">Export
          {{selectedRows.length}} items in PDF</button> -->
      </div>
    </div>

    <div class="btn-export-container shadow"
      style="margin-left: 1rem;margin-right: 1rem;  cursor: pointer;  min-height: 100px;" (click)="request(undefined)">
      <label>Request Inspection/Replacement</label>
      <div class="btn-container" style="justify-content: space-around;">

        <i class="fa fa-comments fa-2x primary" aria-hidden="true"></i>
      </div>
    </div>

    <div class="btn-export-container shadow"
      style="margin-left: 1rem;margin-right: 1rem;  cursor: pointer;  min-height: 100px;" (click)="transfer(undefined)">
      <label>Transfer Equipment</label>
      <div class="btn-container" style="justify-content: space-around;">

        <i class="fa fa-truck fa-2x primary" aria-hidden="true"></i>
      </div>
    </div>

    <div class="btn-export-container shadow" style="margin-left: 0px;margin-right: 0px;min-height: 100px;">
      <label>Register</label>
      <div class="btn-container" style="justify-content: space-around;">

        <button class="btn btn-primary" (click)="exportRegister(0)">Export
          Excel</button>
        <button class="btn btn-primary" (click)="exportRegister(1)">Export
          PDF</button>
        <!-- <button class="btn btn-primary" *ngIf="selectedRows.length > 0" (click)="exportRegister(0)">Export
          {{selectedRows.length}} items in Excel</button>
        <button class="btn btn-primary" *ngIf="selectedRows.length > 0" (click)="exportRegister(1)">Export
          {{selectedRows.length}} items in PDF</button> -->
      </div>
    </div>
  </div>

  <app-loading-icon *ngIf="loading"></app-loading-icon>
  <article class="article " style="margin-top:0.5rem;">
    <div style="display: block;width: 100%;" *ngIf="!loading">

    

      <ngx-datatable #equipmentTable [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size"
        [headerHeight]="50" [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material" 
       [rowClass]="getRowClass" [rows]="rows" [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true" [rowHeight]="'auto'">


        <ngx-datatable-row-detail #myDetailRow (toggle)="onDetailToggle($event)">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <div style="padding-left:35px;margin:0.5rem;"
              *ngIf="row.inspection != undefined && row.inspection.id != undefined">

              <table class="table table-bordered table-condensed report-table" style="width: 95%;" *ngIf="readOnly">
                <tr style="padding: 0.25rem;">
                  <td style="padding: 0.25rem;" class="table-header">Inspection #</td>
                  <td style="padding: 0.25rem;" class="table-header">Exam Date</td>
                  <td style="padding: 0.25rem;" class="table-header">Exam Status</td>
                  <td style="padding: 0.25rem;" class="table-header">Inspector</td>
                  <td style="padding: 0.25rem;" class="table-header">Comments</td>
                  <td style="padding: 0.25rem;" class="table-header">Download</td>
                </tr>
                <tr style="padding: 0.25rem;" *ngFor="let insp of row.inspections">
                  <td style="padding: 0.25rem;">{{insp.report_Number}}</td>
                  <td style="padding: 0.25rem;">{{insp.inspected_At | date: 'dd/MM/yyyy' }}</td>
                  <td style="padding: 0.25rem;">{{insp.inspection_Status}}</td>
                  <td style="padding: 0.25rem;">{{insp.engineer}}</td>
                  <td style="padding: 0.25rem;">{{insp.comments}}</td>

                  <td> <i class="fa fa-file-pdf-o rote" aria-hidden="true" style=" cursor: pointer;"
                      (click)="downloadReport(insp.id, row.serial_Num)" placement="right" ngbTooltip="ROTE Report"></i>
                  </td>
                </tr>
              </table>
              <table class="table table-bordered table-condensed report-table" style="width: 95%;" *ngIf="!readOnly">
                <tr style="padding: 0.25rem;">
                  <td style="padding: 0.25rem;" class="table-header">Archive</td>
                  <td style="padding: 0.25rem;" class="table-header">Inspection #</td>
                  <td style="padding: 0.25rem;" class="table-header">Exam Date</td>
                  <td style="padding: 0.25rem;" class="table-header">Exam Status</td>
                  <td style="padding: 0.25rem;" class="table-header">Inspector</td>
                  <td style="padding: 0.25rem;" class="table-header">Comments</td>
                  <td style="padding: 0.25rem;" class="table-header">Download</td>
                </tr>
                <tr style="padding: 0.25rem;" *ngFor="let insp of row.inspections">
                  <td style="padding: 0.25rem;"> <i class="fa fa-trash danger" style=" cursor: pointer;"
                      (click)="archiveInspection(insp.id)" aria-hidden="true"></i></td>
                  <td style="padding: 0.25rem;">{{insp.report_Number}}</td>
                  <td style="padding: 0.25rem;">{{insp.inspected_At | date: 'dd/MM/yyyy' }}</td>
                  <td style="padding: 0.25rem;">{{insp.inspection_Status}}</td>
                  <td style="padding: 0.25rem;">{{insp.engineer}}</td>
                  <td style="padding: 0.25rem;">{{insp.comments}}</td>

                  <td> <i class="fa fa-file-pdf-o rote" aria-hidden="true" style=" cursor: pointer;"
                      *ngIf="insp.inspection_Status != 'Not Located'" (click)="downloadReport(insp.id, row.serial_Num)"
                      placement="right" ngbTooltip="ROTE Report"></i>
                  </td>
                </tr>
              </table>
            </div>
          </ng-template>
        </ngx-datatable-row-detail>

        <ngx-datatable-column name="History" prop="id" [width]="60" [resizeable]="false" [sortable]="false"
          [draggable]="false" [canAutoResize]="false">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <a *ngIf="row.inspection != undefined && row.inspection.id != undefined" href="javascript:void(0)"
              [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded"
              title="Expand/Collapse Row" (click)="toggleExpandRow(row)">
            </a>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Serial #" prop="serial_Num">
          <ng-template let-value="value" ngx-datatable-cell-template  
   >
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Description" prop="description">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="SWL" prop="swl">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Location" prop="location_Name">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Sub Location" prop="sublocation_Name">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Category" prop="category_Name">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Last Exam Date" prop="inspection.inspected_At">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.inspection != undefined && row.inspection.inspected_At != undefined">{{ value | date:'dd/MM/yyyy' }}</div>
            <div *ngIf="row.inspection == undefined ||row.inspection.inspected_At == undefined">N/A</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Next Exam Date" prop="inspection.next_Inspection_Date">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.inspection != undefined && row.inspection.next_Inspection_Date != undefined">{{ value | date:'dd/MM/yyyy' }}</div>
            <div *ngIf="row.inspection == undefined ||row.inspection.next_Inspection_Date == undefined">N/A</div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Last Exam Status" prop="inspection.inspection_Status" [sortable]="false" [draggable]="false">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.inspection != inspection_Status && row.inspection.inspection_Status != undefined">{{ value
              }}</div>
            <div *ngIf="row.inspection == inspection_Status || row.inspection.inspection_Status == undefined">N/A</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Options" [resizeable]="false" [sortable]="false" [draggable]="false" [width]="125"
          [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div style="display:flex; flex-direction: column;">


              <span *ngIf="!readOnly" style="padding:1%" (click)="edit(row)" class="edit-option danger "><i
                  class="fa fa-pencil" aria-hidden="true"></i>
                Edit</span>

              <span style="padding:1%" (click)="request(row)" class="primary-option "><i class="fa fa-comments"
                  aria-hidden="true"></i> Request</span>

              <span style="padding:1%" (click)="transfer(row)" class="primary-option "><i
                  class="fa fa-truck" aria-hidden="true"></i> Transfer</span>

              <span style="padding:1%" (click)="showUploadedFiles(row)" class="primary-option "><i class="fa fa-folder"
                  aria-hidden="true"></i> Files</span>

              <span style="padding:1%"
                *ngIf="row.inspection != undefined && row.inspection.id != undefined && row.inspection.inspection_Status != 'Not Located'"
                (click)="downloadReport(row.inspection.id, row.serial_Num)" class="primary-option "><i
                  class="fa fa-file-pdf" aria-hidden="true"></i> Download Report</span>


            </div>

          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Basket" [width]="75" prop="id" [resizeable]="false" [sortable]="false" [draggable]="false"
          [canAutoResize]="false">
        
          <ng-template ngx-datatable-header-template let-value="value" let-selectFn="selectFn">
            <div style="display:flex;flex-direction: row;">
              <div style="cursor: pointer;margin-left: 0.5rem;" (click)="addAlltoBasket()">
                <i *ngIf="!allRowsSelected" style="text-align:start;cursor: pointer;" class="fa fa-plus"></i>
              </div>
        
              <div style="cursor: pointer;margin-left: 0.5rem;" (click)="addAlltoBasket()">
                <i *ngIf="allRowsSelected" style="text-align:start;cursor: pointer;" class="fa fa-minus"></i>
              </div>
        
              <span> ({{selectedRows.length}})</span>
            </div>
         
          </ng-template>

          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div class="success" style="cursor: pointer;" (click)="addToBasket(row,1)">
              <i *ngIf="row.inspectionId != null && (row.selected == undefined || row.selected == false) " style="text-align:start;cursor: pointer;"
                class="fa fa-plus"></i>
            </div>
            <div class="danger" style="text-align:start;cursor: pointer;" (click)="removeFromBasket(row,1)"
              *ngIf="(row.selected == true)">
              <i class="fa fa-minus"></i>
            </div>
          </ng-template>
        </ngx-datatable-column>
     </ngx-datatable>
    </div>
  </article>
</div>

<popup-modal id="popup-request">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Request Inspection/Replacement</h2>
      </div>

      <div class="popup-content">
        <div class="input-column">


          <label>Notes</label>
          <textarea wrap="soft" type="text"
            style="resize:vertical;width:100%;margin-bottom: 0.5rem;white-space: pre-wrap;" rows="3" name="messageBody"
            [innerHTML]="requestNotes" placeholder="Please enter any additional information here"
            [(ngModel)]="requestNotes"></textarea>

        </div>

        <div class="popup-footer">
          <div class="btn-container">
            <button class="btn btn-secondary" (click)="cancelModal('popup-request')">Cancel</button>
            <button class="btn btn-primary success" (click)="sendRequest(0)">Request re-inspection</button>
            <button class="btn btn-primary danger" (click)="sendRequest(1)">Request replacement</button>

          </div>
        </div>
      </div>
    </div>
  </article>

</popup-modal>

<popup-modal id="popup-equipment-files">
  <p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>

  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Equipment Files</h2>
      </div>
      <app-loading-icon *ngIf="loading"></app-loading-icon>
      <div class="popup-content" *ngIf="!loading">
        <div class="input-column" *ngIf="!readOnly">

          <div class="form-group" style="width: 25%;">
            <label>Upload</label>
            <input type="file" class="btn btn-primary" style="width: 15rem;min-height: 50px;min-width: 15rem;"
              name="sig" (change)="uploadFile($event)" />
            <label class="small" style="font-size:12;font-style:italic">Please make sure the file size is less than
              5mb</label>
          </div>


          <button class="btn btn-primary" (click)="saveFile()">Save File</button>

        </div>

        <ngx-datatable class="material" [rows]="uploadRows" [columnMode]="'force'" [headerHeight]="50"
          [footerHeight]="50" [rowHeight]="'auto'" [externalPaging]="true" [externalSorting]="true"
          [count]="uploadPage.totalElements" [offset]="uploadPage.pageNumber" [limit]="uploadPage.size"
          (page)='setUploadPage($event)' (sort)="onUploadSort($event)">

          <ngx-datatable-column name="File Name" prop="file_Name">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <div>{{ value }}</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <div class="primary" (click)="downloadFile(row)">
                <i class="fa fa-download" aria-hidden="true"></i> Download
              </div>

            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <span (click)="removeFile(row)" class="edit-option"><i class="fa fa-times" aria-hidden="true"></i>
                Remove</span>
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>

        <div class="popup-footer">
          <div class="btn-container">
            <button class="btn btn-secondary" (click)="cancelModal('popup-equipment-files')">Cancel</button>

          </div>
        </div>
      </div>
    </div>
  </article>

</popup-modal>

<popup-modal id="popup-transfer">
  <article class="popup-artical">
    <div class="popup-container">
      <div class="popup-header">
        <h2>Transferring {{selectedRows.length}} Items</h2>
      </div>

      <div class="popup-content">
        <div class="input-column">
          <div class="form-group" style="width: 100%;">
            <label>Locations</label>
            <app-location-picker [locationId]="selectedPopupLocation" [companyId]="filter.company_Id"
              [_placeholder]="'Please Select'" (onLocationSet)="onpopupLocationChange($event)"></app-location-picker>
          </div>
          <div style="width: 100%;">
            
            <app-sublocation-picker [triggerUpdate]="triggerSubLocationUpdate" [sublocationId]="sublocation_Id"
              [locationId]="selectedPopupLocation" (onSublocationSet)="onSublocationChange($event)"
              [_placeholder]="'Optional'"[hideIfEmpty]="true"></app-sublocation-picker>
          </div>
        </div>
      </div>

      <div class="popup-footer">
        <div class="btn-container">
          <button class="btn btn-secondary" (click)="cancelModal('popup-transfer')">Cancel</button>
          <button class="btn btn-primary" (click)="transferItem()">Save</button>

        </div>
      </div>
    </div>
  </article>

</popup-modal>